/**
 * Scene Component
 * ===============
 * 3D scene komponenti - Canvas va barcha 3D elementlar.
 */

import React, { Suspense } from 'react'
import { Canvas } from '@react-three/fiber'
import './styles.css'
import { Environment } from '@react-three/drei'
import Model1 from './Model1'
import Model2 from './Model2'
import CameraAnimation from './CameraAnimation'
import Effects from './Effects'
import Model3 from './Model3'
import FlyingStars from './FlyingStars'

function Scene({ onProjectClick }) {
  return (
    <Canvas
      dpr={[1, 1.5]}
      camera={{ position: [0, 0, 4], fov: 45, near: 0.01, far: 200 }}
      gl={{
        antialias: true,
        stencil: false,
        powerPreference: 'high-performance',
        failIfMajorPerformanceCaveat: false,
        depth: true,
      }}
      shadows={false}
      flat
    >
      <Suspense fallback={
        <mesh>
          <boxGeometry args={[0.5, 0.5, 0.5]} />
          <meshBasicMaterial color="#333333" wireframe />
        </mesh>
      }>
        <group>
          <Model1 scale={1.3} position={[0, -4, 1.3]} rotation={[-0.1, -0.1, 0]} />
          <Model2 scale={3.3} />
          <Model3 scale={0.02} position={[0, -50.45, 2.136]} rotation={[1.5, 0, 0]} onProjectClick={onProjectClick} />
        </group>

        {/* Environment */}
        <Suspense fallback={null}>
          <Environment files="/studioEnv.hdr" environmentIntensity={0.4} resolution={50} />
        </Suspense>

        <FlyingStars />
        <Effects />
        <CameraAnimation />
      </Suspense>
    </Canvas>
  )
}

export default Scene
